import {
    takeLatest, all, put, call, select,
} from 'redux-saga/effects';
import _ from 'lodash';
import API from '../common/API';
import { waitAuthorizedCheck } from './Auth';
import * as Actions from '../actions/SeminarRegisteredManagermentViewer';

function* getListSeminarRegistered(action) {
    const endpoint = `/api/v1/event/${action.payload.event_name}/seminar_registered/`;
    try {
        const credential = yield call(waitAuthorizedCheck);
        const resultsState = yield select((state) => state.seminarRegisteredManagermentViewer.listSeminarRegistered.data.results);
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
                body: {
                    ...(action.payload?.language && { language: action.payload.language }),
                    page: action.payload.page,
                },
            },
        );
        let dataResult = {};
        if (resultsState) {
            if (_.isArray(response.results)) {
                dataResult = response;
            } else {
                dataResult = { ...response, results: { ...resultsState, ...response.results } };
            }
        } else {
            dataResult = response;
        }
        yield put(Actions.GetListSeminarRegisteredReceived(dataResult));
    } catch (error) {
        yield put(Actions.GetListSeminarRegisteredReceivedFailure(yield error));
    }
}

function* getDetailSeminarRegistered(action) {
    const endpoint = action.payload.language
        ? `/api/v1/event/${action.payload.event_name}/seminar_registered/${action.payload.seminar_id}/?language=${action.payload.language}`
        : `/api/v1/event/${action.payload.event_name}/seminar_registered/${action.payload.seminar_id}/`;
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get, {
                endpoint: `${endpoint}`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailSeminarRegisteredReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailSeminarRegisteredReceivedFailure(yield error));
    }
}
export default function* login() {
    yield all([
        takeLatest('GET_LIST_SEMINAR_REGISTERED_VIEWER_REQUESTED', getListSeminarRegistered),
        takeLatest('GET_DETAIL_SEMINAR_REGISTERED_VIEWER_REQUESTED', getDetailSeminarRegistered),
    ]);
}
